import { HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TokenService } from '../services/token.service';
import { TokenAtualizacaoService } from '../services/token-atualizacao.service';
import { environment } from '../../../environments/environment';

export const AuthInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
    const tokenService = inject(TokenService);
    const tokenAtualizacaoService = inject(TokenAtualizacaoService);

    const isApiRequest = req.url.startsWith(environment.apiBaseUrl) || req.url.startsWith('/');

    if (req.headers.has('skipAuth')) {
        const cleanReq = req.clone({
            headers: req.headers.delete('skipAuth'),
            withCredentials: isApiRequest
        });
        return next(cleanReq);
    }

    const token = tokenService.buscarToken();
    const authReq = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` }, withCredentials: isApiRequest })
        : req.clone({ withCredentials: isApiRequest });

    return next(authReq).pipe(
        catchError((err) => {
            if (err.status === 401 && !req.url.includes('/autenticacao/token-atualizacao')) {
                return from(tokenAtualizacaoService.tentarAtualizarToken()).pipe(
                    switchMap((success) => {
                        if (!success) return throwError(() => err);

                        const novoToken = tokenService.buscarToken();
                        const retried = req.clone({
                            setHeaders: { Authorization: `Bearer ${novoToken}` },
                            withCredentials: isApiRequest
                        });
                        return next(retried);
                    })
                );
            }
            return throwError(() => err);
        })
    );
};
